import React, { useState, useEffect } from 'react';
import { ChevronDown, HelpCircle } from 'lucide-react';
import Navbar from '../components/Navbar';
import SEO from '../components/SEO';

const API = process.env.REACT_APP_BACKEND_URL;

const FAQsPage = () => {
  const [faqs, setFaqs] = useState([]);
  const [openFaq, setOpenFaq] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API}/api/faqs`)
      .then(r => r.ok ? r.json() : [])
      .then(data => { setFaqs(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 pt-16">
      <SEO title="Frequently Asked Questions" description="Find answers to common questions about buying, selling, and renting properties on PropTick." path="/faqs" />
      <Navbar />
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-testid="faqs-title">Frequently Asked Questions</h1>
            <p className="text-lg text-slate-600">Everything you need to know about buying, selling, and renting on PropTick</p>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
            </div>
          ) : faqs.length === 0 ? (
            <div className="text-center py-20">
              <HelpCircle className="w-16 h-16 text-slate-300 mx-auto mb-4" />
              <p className="text-slate-500 text-lg">No FAQs available yet.</p>
            </div>
          ) : (
            <div className="space-y-3" data-testid="faqs-list">
              {faqs.map((faq, idx) => (
                <div key={faq.id} className="bg-white border border-slate-200 rounded-xl overflow-hidden" data-testid={`faq-accordion-${idx}`}>
                  <button
                    onClick={() => setOpenFaq(openFaq === idx ? null : idx)}
                    className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-slate-50 transition-colors"
                    data-testid={`faq-toggle-${idx}`}
                  >
                    <span className="font-semibold text-slate-900 pr-4">{faq.question}</span>
                    <ChevronDown className={`w-5 h-5 text-slate-400 flex-shrink-0 transition-transform duration-200 ${openFaq === idx ? 'rotate-180' : ''}`} />
                  </button>
                  {openFaq === idx && (
                    <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-testid={`faq-answer-${idx}`}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQsPage;
